import _keyBy from 'lodash/keyBy';
import * as Types from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/typings';
import { WEEK_DAY_NAMES } from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/constants';

function getWorkHoursByDayLookup(workHours: Types.DailyWorkHours[]): Types.WorkHoursByDay {
  const workHoursByDay = WEEK_DAY_NAMES.reduce(
    (acc, name) => ({ ...acc, [name]: null }),
    {} as Types.WorkHoursByDay,
  );

  const workingHoursByDay = _keyBy(workHours, workHoursItem => {
    return WEEK_DAY_NAMES[workHoursItem.day];
  });

  const workHoursByDayLookup = {
    ...workHoursByDay,
    ...workingHoursByDay,
  };

  return workHoursByDayLookup;
}

export default getWorkHoursByDayLookup;
